import React from 'react';
import PropTypes from 'prop-types';

function ChevronUp({ size = 20, color, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className={`icon-chevron-up`} d="M16 13L10 7L4 13" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

ChevronUp.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string
}

export default ChevronUp;
